/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Order } from '../models/order';
@Injectable({
  providedIn: 'root',
})
class OrderService extends __BaseService {
  static readonly postOrderPath = '/order';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Create an order
   * @param params The `OrderService.PostOrderParams` containing the following parameters:
   *
   * - `preview`:
   *
   * - `body`: Create an order
   *
   * @return successful operation
   */
  postOrderResponse(params: OrderService.PostOrderParams): __Observable<__StrictHttpResponse<Array<Order>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.preview != null) __params = __params.set('preview', params.preview.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/order`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Order>>;
      })
    );
  }
  /**
   * Create an order
   * @param params The `OrderService.PostOrderParams` containing the following parameters:
   *
   * - `preview`:
   *
   * - `body`: Create an order
   *
   * @return successful operation
   */
  postOrder(params: OrderService.PostOrderParams): __Observable<Array<Order>> {
    return this.postOrderResponse(params).pipe(
      __map(_r => _r.body as Array<Order>)
    );
  }
}

module OrderService {

  /**
   * Parameters for postOrder
   */
  export interface PostOrderParams {
    preview: boolean;

    /**
     * Create an order
     */
    body: Order;
  }
}

export { OrderService }
